import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 10,
    fontSize: 18,
    flexDirection: 'column',
    paddingBottom: 20,
    width: '90vw',
    margin: '0 auto',
  },

  header: {
    width: '100%',
    padding: '2rem 0',
  },

  searchForm: {
    marginTop: '2rem',
    width: '100%',
    padding: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
  },

  leftWrapper: {
    display: 'flex',
    width: 'fit-content',
    minWidth: '50rem',
    alignItems: 'center',
  },

  rightWrapper: {
    display: 'flex',
    gap: '1rem',
    width: 'fit-content',
    alignItems: 'center',
    margin: '0 1.5rem',
  },
  
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  
  table: {
    width: '100%',
  },

  pagination: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '1.25rem',
    backgroundColor: Colors.lightGray,
  },
}))

export default styles
